// extracted by mini-css-extract-plugin
export var closeHandElementContainer = "IntroSection-module--closeHandElementContainer--Lql63";
export var introSection = "IntroSection-module--introSection--s7c7U";
export var introSectionContainer = "IntroSection-module--introSectionContainer--YisFt";
export var openHandElementContainer = "IntroSection-module--openHandElementContainer--RwurS";
export var text = "IntroSection-module--text--FRqvu";
export var title = "IntroSection-module--title--yUm06";